import script from "./index.vue?vue&type=script&setup=true&scoped=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&scoped=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=43b5db8a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b5db8a"]])

export default __exports__